export default [
  {
    path: '/Personal/Pay',
    component: () => import('@/views/PersonalCenter/Pay/Index'),
    name: 'Pay',
    meta: {
      title: '支付',
      noCache: true,
      affix: true,
      requireAuth: true
    }
  },
  {
    path: '/Personal/PaySuccess',
    component: () => import('@/views/PersonalCenter/Pay/Success'),
    name: 'PaySuccess',
    meta: {
      title: '支付成功',
      noCache: true,
      affix: true,
      requireAuth: true
    }
  },
  {
    path: '/Personal/PayFail',
    component: () => import('@/views/PersonalCenter/Pay/Fail'),
    name: 'PayFail',
    meta: {
      title: '支付失败',
      noCache: true,
      affix: true,
      requireAuth: true
    }
  }
]
